import React, { useEffect, useState } from "react";
import "./DuplicateCampaign.css";
import {
  Button,
  Form,
  Row,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import FloatingInput from "../../common/float-input/FloatInput";
import { useDispatch, useSelector } from "react-redux";
import { duplicateCampaign } from "../../../store/thunks/buyer-thunks/BuyerThunks";

const DuplicateCampaign = ({
  duplicateEntireCampaign,
  setDuplicateEntireCampaign,
  campaignId,
  campaignName,
}) => {
  const dispatch = useDispatch();
  const [camapaignName, setCampaignName] = useState({
    id: campaignId,
    name: "",
  });
  const { isLoading, isDuplicating } = useSelector(
    (state) => state.buyerCampaigns
  );
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const handleDuplicateCampaign = (e) => {
    dispatch(duplicateCampaign(camapaignName)).then((res) => {
      if (res?.payload?.status == 1) {
        e.preventDefault();
        setDuplicateEntireCampaign(false); // Reset editing mode
      }
    }); // Send data to Redux
  };
  const { Text } = Typography;

  // Update campaign_id when campaignId prop changes
  useEffect(() => {
    if (duplicateEntireCampaign) {
      setCampaignName((prev) => ({
        ...prev,
        id: campaignId,
        name: campaignName || "",
      }));
    }
  }, [duplicateEntireCampaign, campaignId, campaignName]);
  return (
    <>
      <div>
        <Row>
          <Text className="share-camapign-model-header">
            Duplicate Campaign
          </Text>
        </Row>
        <Form onSubmitCapture={handleDuplicateCampaign}>
          <Form.Item name="name" required>
            <Row>
              <FloatingInput
                label={
                  <>
                    {`Enter name for the duplicate campaign `}
                    {star}
                  </>
                }
                customStyles={floatingInputStyles}
                value={camapaignName?.name}
                onChange={(e) =>
                  setCampaignName({
                    ...camapaignName,
                    name: e.target.value.replace(/^\s+/, ""),
                  })
                }
                className="billboard-input-feild"
              />
            </Row>
          </Form.Item>
          <Row justify="end" style={{ gap: "0.5rem" }}>
            <Button
              className="billboard-buttons billboard-button-1"
              onClick={(e) => {
                setDuplicateEntireCampaign(false);
                setCampaignName({
                  id: campaignId,
                  name: campaignName,
                });
              }}
            >
              Cancel
            </Button>
            <Button
              className={`billboard-buttons billboard-button-2 ${
                !camapaignName?.name ? "disabled-opacity" : ""
              }`}
              htmlType="submit"
            >
              Duplicate
            </Button>
          </Row>
        </Form>
      </div>
      {isLoading ||
        (isDuplicating && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        ))}
    </>
  );
};

export default DuplicateCampaign;
